/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface Subscriber {
  activeControlId?: number;
  addressId?: number;
  amount?: number;
  attempt?: number;
  billingIsShipping?: boolean;
  boxId?: string;
  creditCardId?: number;
  customerIODatesynced?: Date;
  cycleStartEdition?: number;
  dateCreated?: Date;
  dateUpdated?: Date;
  discount?: number;
  endEdition?: number;
  endOfCycle?: boolean;
  installments?: number;
  inviterId?: number;
  lastEdition?: number;
  lastSync?: Date;
  maxAttempts?: number;
  nextAttemptDate?: Date;
  nextCycleDate?: Date;
  nextEdition?: number;
  nextPaymentDate?: Date;
  nextSync?: Date;
  paymentMethod?: Subscriber.PaymentMethodEnum;
  paymentOrderId?: number;
  personId?: number;
  preferredGatewayId?: number;
  recurrence?: number;
  recurrenceStatusId?: number;
  recurrentPaymentId?: number;
  remainingEditions?: number;
  startEdition?: number;
  subscriberBadgeId?: number;
  subscriberId?: number;
  subscriberPagarme?: number;
  subscriberPaymentTypeId?: number;
  subscriberStatus?: number;
  subscriptionId?: number;
  subscriptionPrice?: number;
  subscriptionTypeId?: number;
}
export namespace Subscriber {
  export type PaymentMethodEnum = 'CREDIT_CARD' | 'PIX';
  export const PaymentMethodEnum = {
    CREDITCARD: 'CREDIT_CARD' as PaymentMethodEnum,
    PIX: 'PIX' as PaymentMethodEnum
  };
}
